import React from "react";
import { FacilityOrderTemplateNewFlowCustomOrderingDoctorAddTemplate } from "themes/application/facility-order-new-flow/components";
import { FacilityOrderTemplateNewFlowCustomOrderingDoctorAddViewStore } from 'application/facility-order-new-flow/stores';
import { observer } from "mobx-react";
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateNewFlowCustomOrderingDoctorAddViewStore(rootStore, componentProps), 'facilityOrderTemplateNewFlowCustomOrderingDoctorAddViewStore')
@observer
class FacilityOrderTemplateNewFlowCustomOrderingDoctorAdd extends React.Component {
	render() {
		return <FacilityOrderTemplateNewFlowCustomOrderingDoctorAddTemplate {...this.props} />;
	}
}

export default FacilityOrderTemplateNewFlowCustomOrderingDoctorAdd;